<template>
  <div class="videoPlayer">
    <div class="title">{{ videoDetail.VideoTitle || '' }}</div>
    <div class="msg-box">
      <p>{{videoDetail.VideoCreateTime | times}}</p>
    </div>
    <div class="video-box">
      <VideoM3U8 v-if="isM3U8" :videoUrl="videoDetail.VideoPath" />
      <video
        v-else
        :src="videoDetail.VideoPath"
        :poster="videoDetail.VideoImage | img2"
        autoplay
        controls="controls"
        id="_video"
      />
    </div>
    <div class="msg-box">
      <p class="tip">视频课程版权归中央党校（国家行政学院）所有，除供基层单位和基层党组织开展集中学习使用外，
        任何机构或个人不得通过广播电视、互联网、移动通讯网、各类应用软件及其他任何音视频传播技术或平台，
        以直播、延播、点播、轮播、回看、剪辑、动图等方式使用。如有侵权将追责。
      </p>
    </div>
  </div>
</template>

<script>
import VideoM3U8 from '@/components/VideoM3U8/index'

import { getVideoDetail, setFootmarl } from '@/api/common.js'

export default {
  components: { VideoM3U8 },
  data() {
    return {
      userid: Number(sessionStorage.getItem('id') || 0),
      id: 0,
      videoDetail: {}
    }
  },
  computed: {
    isM3U8 () {
      return this.videoDetail?.VideoPath?.includes('m3u8')
    }
  },
  created () {
    this.id = this.$route.query?.id || 0
    this.initData()
  },
  methods: {
    initData () {
      const params = {
        Vid: this.id,
        uid: this.userid
      }
      getVideoDetail(params).then(res => {
        const { code, msg } = res
        this.videoDetail = code === 0 ? msg || {} : {}
        if (code === 0) this.setFootmarl()
      })
    },
    setFootmarl () {
      const params = {
        name:'我的视频足迹',
        token: sessionStorage.getItem('token') || '',
        loginname: this.videoDetail.VideoTitle,
        town: window.location.href
      }
      setFootmarl(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.videoPlayer {
  .other-video {
    .class-box {
      .class-template {
        &:nth-child(odd) {
          margin-right: 2%;
        }
        img {
          width: 100%;
        }
        p {
          &:nth-child(3) {
            color: #999999;
          }
          line-height: 2;
          padding: 0 0.2rem;
          font-size: 0.26rem;
        }
        width: 49%;
        background: #fff;
        margin-top: 0.3rem;
        padding-bottom: 0.2rem;
      }
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      padding: 0 0.2rem;
    }
    .title {
      span {
        font-weight: bold;
        font-size: 0.36rem;
      }
      img {
        width: 0.38rem;
        height: 0.45rem;
        margin-right: 0.1rem;
      }
      display: flex;
      align-items: center;
      background: #fff;
      line-height: 3;
    }
    margin-top: 0.3rem;
  }
  .video-box {
    width: 100%;
    height: 4rem;
    padding: 0 0.2rem;
    margin-top: 0.3rem;
    text-align: center;
    video {
      width: 100%;
    }
  }
  .msg-box {
    color: #999;
    padding: 0 0.2rem;
    .tip {
      margin-top: 0.3rem;
      text-indent: 2em;
    }
  }
  .title {
    line-height: 2;
    font-weight: bold;
    font-size: 0.36rem;
    padding: 0 0.2rem;
  }
  padding-top: 1.2rem;
  font-size: 0.3rem;
}
</style>